import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-legal">

     
 </div>
  );
};

export default PrivacyPolicy;